import React, {useEffect, useRef, useState} from 'react';
import {API_ENDPOINTS} from "../apiConfig";
import API from "../utils/API";
import Error from "./Error";
import Forms from "./Forms";
import {useTranslation} from 'react-i18next';

const PartCategoryModal = ({close, onCategoryAdded, partCategory}) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [parentCategory, setParentCategory] = useState(null);
    const [categoryCode, setCategoryCode] = useState('');
    const inputRef = useRef(null);

    const [error, setError] = useState();
    const [categories, setCategories] = useState([]);
    const {t} = useTranslation();

    useEffect(() => {
            setTimeout(() => {
                inputRef.current.focus();
            }, 1);
    }, []);

    useEffect(() => {
        setName(partCategory ? partCategory.name : '');
        setDescription(partCategory ? partCategory.description : '');
        setCategoryCode(partCategory ? partCategory.code : '');
        setParentCategory(
            partCategory?.parent
                ? {
                    value: partCategory.parent?._id || partCategory.parent,
                    label: partCategory.parent?.name || ''
                }
                : null
        );
    }, [partCategory]);

    const fetchCategories = async () => {
        try {
            const response = await API.get(API_ENDPOINTS.part.categories);
            setCategories(response.data);
        } catch (error) {
            console.error("Failed to fetch categories:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError();

        const categoryData = {
            name,
            description,
            code: categoryCode,
            parent: parentCategory?.value || null
        };

        try {
            if (partCategory) {
                await API.put(`${API_ENDPOINTS.part.categories}/${partCategory._id}`, categoryData);
            } else {
                await API.post(API_ENDPOINTS.part.categories, categoryData);
            }
            onCategoryAdded();
            close();
        } catch (error) {
            setError(error);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-4 mb-4 items-start">
                <Forms.Text
                    ref={inputRef}
                    required
                    placeholder="Název"
                    value={name}
                    onChange={(val) => setName(val)}
                    className="rounded-t-md"
                />
                <Forms.Text
                    required
                    placeholder="Kód kategorie (IP11PM)"
                    value={categoryCode}
                    onChange={(val) => setCategoryCode(val)}
                    className="rounded-t-md"
                />
                <Forms.Text
                    required
                    placeholder="Popis"
                    value={description}
                    onChange={(val) => setDescription(val)}
                    className="rounded-b-md"
                />
                <Forms.Select
                    placeholder="Nadřazená kategorie"
                    value={parentCategory}
                    options={categories.map(
                        category => ({
                            value: category._id,
                            label: category.name
                        })
                    )}
                    onChange={(val) => setParentCategory(val)}
                    className="rounded-b-md"
                />
            </div>

            {error && <Error error={error}/>}
            <Forms.Button
                submit
                label={partCategory ? t('update') : t('save')}
                className="mt-4"
            />
        </form>
    );
};

export default PartCategoryModal;
